import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { theme } from '../../modules/App/Providers/Theme/theme'

const Muted = styled(Typography)`
  color: ${theme.palette.grey[600]};
`

const Subtitle: FC = ({ children }) => <Muted variant="h3">{children}</Muted>

export { Subtitle }
